export default "__VITE_ASSET__BFcugkqc__"